import { Mui } from "@osu/react-ui";
import { Fragment } from "react";

const decideOnProps = ({
  loading,
  from,
  to,
  success,
  error
}) => {
    const alertProps = {};
  const baseAlertProps = {
    component: Mui.Alert,
    sx: {
      mb: 2
    }
  };
  const hiddenProps = {
    component: undefined,
    sx: {
      display: 'none',
    }
  };
  if (loading && from && to) {
    Object.assign(alertProps, baseAlertProps);
    alertProps.severity = "info";
    alertProps.children = (
      <Fragment>
        Changing status from {from} to <strong>{to}</strong>...
      </Fragment>
    );
  } else if (error) {
    Object.assign(alertProps, baseAlertProps);
    alertProps.severity = "error";
    alertProps.children = (
      <Fragment>
        An error occurred changing status, try refreshing the page and retrying.
      </Fragment>
    );
  } else if (success) {
    Object.assign(alertProps, baseAlertProps);
    alertProps.severity = "success";
    alertProps.children = (
      <Fragment>
        Status changed from {from} to <strong>{to}</strong>
      </Fragment>
    )
  } else {
    Object.assign(alertProps, hiddenProps);
  }
  return alertProps
}

function StatusAlert(props = {}) {
  const {  to, from, success, loading, error, ...rest } = props
  const alertProps = decideOnProps({
    to,
    from,
    success,
    loading,
    error
  });
  return (
    <Mui.Box
      role="status"
      aria-live="polite"
      {...alertProps}
      {...rest}
    />
  );
}

export default StatusAlert;
